<template>
  <div class="listpage">
    <div class="breadcrumb">
      <div class="content">
        <img class="homelogo" src="../assets/img/home.png">
        <span>当前位置： </span>
        <span>首页</span>
        >
        <span>{{title}}</span>
      </div>
      <div v-if="type!=4">
        <input type="text" class="search2" v-model="pagekeyword" @keyup.enter = "Query">
        <button class="searchbot2" @click="Query">
           <img style="height: 20px;margin-top: 6px;margin-left: 2px;" src="../assets/img/search.png" alt="">
        </button>
      </div>
    </div>
    <div class="z_detail">
            <div class="l_title">
                <h2 v-if="type!=4">{{title}}</h2>
                <h2 v-else>找到关于“{{keyword}}”，共{{pagination.total}}个结果</h2>
            </div>
            <div v-if="type!=2&&type!=99&&categoryId!='05'&&categoryId!='12'" class="lista">
                <ul>
                    <li v-for="(item,index) of List" :key="index">
                        <div class="listtitle">
                          <router-link v-if="type==0" :to="'/detail?articleId='+item.articleId" >{{item.title}}<span style="color: #f45831;" v-if="item.onTop==1&&categoryId=='02'">【重要通知】</span></router-link>
                          <router-link v-else-if="type==1" :to="'/detail?bulletinId='+item.bulletinId" ><span style="display: inline-block;margin-right: 15px;color: #686868;">{{item.prjNo}}</span>{{item.prjName}}</router-link>
                          <span v-else-if="type==3">{{item.customerName}}</span>
                          <router-link v-else-if="type==5" :to="'/detail?newsId='+item.articleId" >{{item.title}}</router-link>
                          <span v-else>
                            <router-link v-if="item.type==1" :to="'/detail?bulletinId='+item.articleId+'&articleId='+item.articleId" >{{item.title}}</router-link>
                            <router-link v-else :to="'/detail?bulletinId='+item.articleId" >{{item.title}}</router-link>
                          </span>
                        </div>
                        <div v-if="type==0||type==4">{{GetDate(item.publishDate)}}</div>
                        <div v-else-if="type==1">{{GetDate(item.kbDate)}}</div>
                        <div v-else-if="type==3">{{item.count_project}}宗</div>
                        <div v-else-if="type==5">{{GetDate(item.create_date)}}</div>
                    </li>
                </ul>
            </div>
            <div v-if="type==2" class="listc">
              <div class="listmenu">
                <ul class="listul">
                  <li>
                    <span @click="UlOpen1">公告类型</span>
                    <!-- <ul :class="isopen1?'':'ulclose'"> -->
                    <ul>
                      <li :class="menu=='01'+item.code?'active':''"  v-for="(item,index) of menuList1" :key="index" @click="ButtonClickL('01',item.code,'1')">
                        {{item.name}}
                      </li>
                    </ul>
                  </li>
                  <!-- <li>
                    <span @click="UlOpen1">非进场项目公告</span>
                    <ul>
                      <li :class="menu==item.code?'active':''"  v-for="(item,index) of menuList2" :key="index" @click="ButtonTyClickL(item.code)">
                        {{item.name}}
                      </li>
                    </ul>
                  </li> -->
                  <!-- <li>
                    <span @click="UlOpen2">非招标采购</span>
                    <ul :class="isopen2?'':'ulclose'">
                      <li :class="menu=='02'+item.code?'active':''"  v-for="(item,index) of menuList2" :key="index" @click="ButtonClickL('02',item.code,'2')">
                        {{item.name}}
                      </li>
                    </ul>
                  </li> -->
                </ul>
              </div>
              <div v-if="!isJC" class="listcontent">
                <div class="topmenu">
                  <span v-for="(item,index) of topmenuList" :key="index" @click="ButtonClickT(item.code)" :class="top==item.code?'topRactive':''">{{item.name}}</span>
                </div>
                <ul>
                    <li v-for="(item,index) of List" :key="index">
                        <div class="listtitle">
                          <!-- <router-link :to="'/detail?bulletinId='+item.autoId" ><span class="listbtype">【{{item.infoTypeId == "D01" -->
                          <router-link :to="item.autoId==''?listParams.classID!=22?'/detail?type=1&prjId='+item.prjId:'/detail?type=10&prjId='+item.prjId:'/detail?bulletinId='+item.autoId" ><span class="listbtype">【{{item.infoTypeId == "D01"
                          ? "货物"
                          : item.infoTypeId == "D02"||item.infoTypeId == "D05"||item.infoTypeId == "D06"
                          ? "工程"
                          : item.infoTypeId == "D03"
                          ? "服务"
                          : "其他"}}】</span><span>{{item.prjNo}}&nbsp;&nbsp;</span>{{item.bulletinTitle}}</router-link>
                        </div>
                        <div style="line-height: 23px;">{{GetDate(item.publishDate)}}</div>
                    </li>
                </ul>
              </div>
              <div v-else class="listcontent">
                <div class="topmenu">
                  <span v-for="(item,index) of topmenuList2" :key="index" @click="ButtonTyClickT(item.code)" :class="top==item.code?'topRactive':''">{{item.name}}</span>
                </div>
                <ul>
                    <li v-for="(item,index) of List" :key="index">
                        <div class="listtitle">
                          <!-- <router-link :to="'/detail?bulletinId='+item.autoId" ><span class="listbtype">【{{item.infoTypeId == "D01" -->
                          <router-link :to="'/detail?type=99&articleId=' + item.autoId" >
                            {{item.bulletinTitle}}</router-link>
                        </div>
                        <div style="line-height: 23px;">{{GetDate(item.publishDate)}}</div>
                    </li>
                </ul>
              </div>
            </div>
            <div v-if="type==99" class="listc">
              <div class="listmenu">
                <ul class="listul">
                  <li>
                    <span @click="UlOpen1">非进场项目公告</span>
                    <!-- <ul :class="isopen1?'':'ulclose'"> -->
                    <ul>
                      <li :class="menu==item.code?'active':''"  v-for="(item,index) of menuList2" :key="index" @click="ButtonTyClickL(item.code)">
                        {{item.name}}
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <div class="listcontent">
                <div class="topmenu">
                  <span v-for="(item,index) of topmenuList2" :key="index" @click="ButtonTyClickT(item.code)" :class="top==item.code?'topRactive':''">{{item.name}}</span>
                </div>
                <ul>
                    <li v-for="(item,index) of List" :key="index">
                        <div class="listtitle">
                          <!-- <router-link :to="'/detail?bulletinId='+item.autoId" ><span class="listbtype">【{{item.infoTypeId == "D01" -->
                          <router-link :to="'/detail?type=99&articleId=' + item.autoId" >
                            {{item.bulletinTitle}}</router-link>
                        </div>
                        <div style="line-height: 23px;">{{GetDate(item.publishDate)}}</div>
                    </li>
                </ul>
              </div>
            </div>
            <div v-if="categoryId=='05'||categoryId=='12'" class="listc listZC">
              <div class="listmenu">
                <ul>
                  <li :class="SubCategoryId==item.classId?'active':''"  v-for="(item,index) of SubCategoryList" :key="index" @click="subCategoryClick(item.classId)">
                    {{item.className}}
                  </li>
                </ul>
              </div>
              <div class="listcontent">
                <ul v-if="type=='0'||(type=='3'&&cateId!='000001')">
                    <li v-for="(item,index) of List" :key="index">
                        <div class="listtitle">
                          <router-link :to="'/detail?articleId='+item.articleId" >
                          {{item.title}}
                          </router-link>
                        </div>
                        <div style="line-height: 23px;">{{GetDate(item.publishDate)}}</div>
                    </li>
                </ul>
                <ul v-else>
                    <li v-for="(item,index) of List" :key="index">
                        <div class="listtitle">
                          <span>{{item.customerName}}</span>
                        </div>
                        <div>{{item.count_project}}宗</div>
                    </li>
                </ul>
              </div>
            </div>
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-size="pagination.pageSize"
                    layout="total, prev, pager, next"
                    :total="pagination.total">
                </el-pagination>
            </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
// eslint-disable-next-line standard/object-curly-even-spacing
import { GetListByCategoryId, GetSubCategoryList } from '@/api/article'
import { GetBulletinList, GetBulletinTyList, GetNewsList } from '@/api/Home'
import { GetOpenList, GetIntegrityList, GetSearchInfo } from '@/api/protal'
export default {
  data () {
    return {
      currentPage: 1,
      title: '',
      isopen1: false,
      isopen2: false,
      isJC: false,
      isZBCG: '1',
      titlelist: [
        {
          id: '1',
          title: '平台介绍'
        },
        {
          id: '2',
          title: '通知动态'
        },
        {
          id: '3',
          title: '交易信息'
        },
        {
          id: '4',
          title: '政策法规'
        },
        {
          id: '5',
          title: '常见问题'
        },
        {
          id: '6',
          title: '资料下载'
        },
        {
          id: '7',
          title: '办事指南'
        },
        {
          id: '8',
          title: '诚信专栏'
        },
        {
          id: '9',
          title: '近期开标'
        },
        {
          id: '10',
          title: '新闻动态'
        },
        {
          id: '99',
          title: '非进场项目交易公告'
        }
      ],
      List: [],
      menuList1: [
        {
          name: '采购公告',
          code: '21'
        },
        {
          name: '变更公告',
          code: '23'
        },
        {
          name: '候选人公示',
          code: '22'
        },
        {
          name: '结果公告',
          code: '24'
        },
        {
          name: '采购文件预公示',
          code: '20'
        },
        {
          name: '异常公告',
          code: '26'
        },
        {
          name: '其他公告',
          code: '29'
        }
      ],
      menuList2: [
        {
          name: '招标公告',
          code: '001'
        },
        {
          name: '变更公告',
          code: '002'
        },
        {
          name: '开标记录',
          code: '006'
        },
        {
          name: '候选人公示',
          code: '003'
        },
        {
          name: '结果公示',
          code: '004'
        },
        {
          name: '其他公告',
          code: '005'
        }
      ],
      topmenuList: [
        {
          name: '全部',
          code: null
        },
        {
          name: '工程',
          code: 'D02'
        },
        {
          name: '货物',
          code: 'D01'
        },
        {
          name: '服务',
          code: 'D03'
        },
        {
          name: '其他',
          code: 'D04'
        }
      ],
      topmenuList2: [
        {
          name: '招标采购',
          code: '001002001'
        },
        {
          name: '非招标采购',
          code: '001002002'
        }
      ],
      SubCategoryList: [],
      listParams: {
        pageIndex: 1,
        pageSize: 15
      },
      pagekeyword: '',
      className: '变更公告',
      cateId: 0,
      SubCategoryId: 0,
      pagination: {
        total: 0,
        pageSize: 15,
        onChange: this.pageChange
      },
      menu: '0121',
      top: null
    }
  },
  computed: {
    type () {
      return this.$route.query.type // type = 0 文章列表 type = 1 项目列表  type = 2 公告列表 3 诚信专栏列表,4:首页搜索列表
    },
    keyword () {
      return this.$route.query.keyword
    },
    categoryId () {
      return this.$route.query.categoryId
    },
    noticeType () {
      return this.$route.query.noticeType
    },
    InfoTypeId () {
      return this.$route.query.InfoTypeId
    }
  },
  methods: {
    ...mapMutations(['SET_NAV_NAME']),
    UlOpen1 () {
      if (this.isopen1) {
        this.isopen1 = false
      } else {
        this.isopen1 = true
      }
    },
    UlOpen2 () {
      if (this.isopen2) {
        this.isopen2 = false
      } else {
        this.isopen2 = true
      }
    },
    GetDate (date) {
      var day = ''
      if (date) {
        day = date.slice(0, 10)
      }
      return day
    },
    handleSizeChange (size) {
      alert('翻页1' + size)
    },
    handleCurrentChange (page) {
      this.listParams.pageIndex = page
      if (this.selectSubNav !== '20' && this.selectSubNav !== '28') {
        this.listParams.InfoTypeId = this.top
        // this.listParams.isZBCG = this.isZBCG
      } else {
        this.listParams.ZtbTypeId = null
        this.listParams.InfoTypeId = null
      }
      this.getListData()
    },
    GetSubCategory () {
      if (this.type === '0') {
        GetSubCategoryList({ categoryId: this.categoryId }).then((res) => {
          this.SubCategoryList = res.data
          if (this.SubCategoryList.length > 0) {
            this.SubCategoryId = this.SubCategoryList[0].classId
            this.cateId = this.SubCategoryId
          }
          this.listParams.pageIndex = 1
          this.getListData()
        })
      } else if (this.type === '3') {
        GetSubCategoryList({ categoryId: this.categoryId }).then((res) => {
          // this.SubCategoryList = res.data
          this.SubCategoryList = [
            {
              className: '代理机构',
              classId: '000001'
            }, ...res.data
          ]
          if (this.SubCategoryList.length > 0) {
            this.SubCategoryId = this.SubCategoryList[0].classId
            this.cateId = this.SubCategoryId
          }
          this.listParams.pageIndex = 1
          this.getListData()
        })
      } else {
        this.listParams.pageIndex = 1
        this.getListData()
      }
    },
    Query () {
      this.listParams.keyword = this.pagekeyword
      this.top = null
      if (this.type === '99') {
        this.top = this.InfoTypeId
      }
      this.getListData()
    },
    getListData () {
      console.log(1)
      this.spinning = true
      this.className = this.$route.query.class
      this.listParams.categoryId = this.cateId
      if (this.type === '0') {
        // 文章列表
        GetListByCategoryId(this.listParams).then((res) => {
          this.List = res.data.articleList
          this.pagination.total = res.data.total
          // console.log(res);
          this.spinning = false
        })
      } else if (this.type === '1') {
        // 今日开标列表
        // eslint-disable-next-line no-undef
        GetOpenList(this.listParams).then((res) => {
          this.List = res.data.projectList
          this.pagination.total = res.data.total
          this.spinning = false
        })
      } else if (this.type === '2') {
        if (!this.isJC) {
          this.GetBulletin(this.noticeType)
        } else {
          this.listParams.ClassID = this.noticeType
          this.listParams.InfoTypeId = this.InfoTypeId
          GetBulletinTyList(this.listParams).then((res) => {
            this.List = res.data.bulletinList
            this.pagination.total = res.data.total
            this.spinning = false
          })
        }
        // 公告列表
      } else if (this.type === '3') {
        // 诚信专栏列表
        // eslint-disable-next-line no-undef
        if (this.SubCategoryId === '000001') {
          GetIntegrityList(this.listParams).then((res) => {
            this.List = res.data.integrityList
            this.pagination.total = res.data.total
            this.spinning = false
          })
        } else {
          GetListByCategoryId(this.listParams).then((res) => {
            this.List = res.data.articleList
            this.pagination.total = res.data.total
            // console.log(res);
            this.spinning = false
          })
        }
      } else if (this.type === '4') {
        this.listParams.keyword = this.keyword
        // eslint-disable-next-line no-undef
        GetSearchInfo(this.listParams).then((res) => {
          this.List = res.data.searchList
          this.pagination.total = res.data.total
          this.spinning = false
        })
      } else if (this.type === '5') {
        // eslint-disable-next-line no-undef
        GetNewsList().then((res) => {
          this.List = res.data.articles
          this.pagination.total = res.total
          this.spinning = false
        })
      } else if (this.type === '99') {
        // eslint-disable-next-line no-undef
        this.listParams.ClassID = this.noticeType
        this.listParams.InfoTypeId = this.InfoTypeId
        GetBulletinTyList(this.listParams).then((res) => {
          this.List = res.data.bulletinList
          this.pagination.total = res.data.total
          this.spinning = false
        })
      }
    },
    GetBulletin (selectSubNav) {
      this.spinning = true
      this.selectSubNav = selectSubNav

      if (selectSubNav === '21') {
        this.className = '采购公告'
      } else if (selectSubNav === '23') {
        this.className = '变更公告'
      } else if (selectSubNav === '22') {
        this.className = '候选人公示'
      } else if (selectSubNav === '24') {
        this.className = '结果公告'
      } else if (selectSubNav === '20') {
        this.className = '采购文件预公示'
      } else if (selectSubNav === '28') {
        this.className = '年度采购预公示'
      }
      this.listParams.classID = selectSubNav
      if (this.selectSubNav !== '20' && this.selectSubNav !== '28') {
        this.listParams.InfoTypeId = this.top
        // this.listParams.isZBCG = this.isZBCG
      } else {
        this.listParams.ZtbTypeId = null
        this.listParams.InfoTypeId = null
      }
      GetBulletinList(this.listParams).then((res) => {
        this.List = res.data.bulletinList
        this.pagination.total = res.data.total
        this.spinning = false
      })
    },
    ButtonClickL (menutype, noticeType, ZBCG) {
      this.menu = menutype + noticeType
      if (this.isJC) {
        this.isJC = false
        this.top = null
      }
      // this.isZBCG = ZBCG
      this.$router.push({
        path: this.$route.path,
        query: {
          type: this.type,
          class: this.class,
          noticeType: noticeType,
          InfoTypeId: this.top
        }
      })
    },
    ButtonTyClickL (noticeType) {
      this.menu = noticeType
      if (!this.isJC) {
        this.isJC = true
        this.top = '001002001'
      }
      // this.isZBCG = ZBCG
      this.$router.push({
        path: this.$route.path,
        query: {
          type: this.type,
          class: this.class,
          noticeType: noticeType,
          InfoTypeId: this.top
        }
      })
    },
    ButtonClickT (InfoTypeId) {
      this.top = InfoTypeId
      this.$router.push({
        path: this.$route.path,
        query: {
          type: this.type,
          class: this.class,
          noticeType: this.menu.slice(2, 4),
          InfoTypeId: InfoTypeId
        }
      })
    },
    ButtonTyClickT (InfoTypeId) {
      this.top = InfoTypeId
      this.$router.push({
        path: this.$route.path,
        query: {
          type: this.type,
          class: this.class,
          noticeType: this.menu,
          InfoTypeId: InfoTypeId
        }
      })
    },
    subCategoryClick (categoryId) {
      this.cateId = categoryId
      this.SubCategoryId = categoryId
      this.getListData()
    },
    GetTitle (titleId) {
      for (var i = 0; i < this.titlelist.length; i++) {
        if (titleId === this.titlelist[i].id) {
          return this.titlelist[i].title
        }
      }
      return ''
    }
  },
  mounted () {
    if (this.type === '99') {
      this.top = this.InfoTypeId
      this.menu = this.noticeType
    }
    if (this.type === '3') {
      this.cateId = '000001'
      this.SubCategoryId = '000001'
    }
    const query = this.$route.query
    this.title = this.GetTitle(query.class)
    this.SET_NAV_NAME(this.title)
    // this.ztbParams.ZtbTypeId = this.isZBCG
    // GetZtbType().then((res) => {
    //   this.ButtonDate = res.data
    //   this.selectSubNav = this.noticeType
    //   // this.SET_NAV_NAME(this.className)
    //   this.cateId = this.categoryId
    //   this.GetSubCategory()
    // })
    // GetinfoType().then((res) => {
    this.selectSubNav = this.noticeType
    // this.SET_NAV_NAME(this.className)
    this.cateId = this.categoryId
    this.GetSubCategory()
    // })
  },
  watch: {
    $route: {
      handler () {
        const query = this.$route.query
        this.title = this.GetTitle(query.class)
        this.cateId = this.categoryId
        this.listParams.keyword = ''
        this.pagekeyword = ''
        this.SET_NAV_NAME(this.title)
        // if (query.ZBCG) {
        //   this.ztbParams.ZtbTypeId = query.ZBCG
        // } else {
        //   this.ztbParams.ZtbTypeId = this.isZBCG
        // }
        this.GetSubCategory()
      }
    }
  }
}
</script>

<style scoped>
.l_title{
    width: 100%;
    text-align: left;
    margin-bottom: 20px;
    height: 50px;
    border-bottom: 1px solid #e8e8e8;
}
.lista{
  min-height: 266px;
}
.lista ul{
    list-style-type: none;
    padding: 0;
}
.lista li{
    width: 100%;
    border-bottom: 1px solid #e8e8e8;
    padding: 8px 0;
    display: flex;
    justify-content: space-around;
}
.listcontent{
  width: 1250px;
  height: 638px;
}
.listcontent li{
    width: 100%;
    border-bottom: 1px solid #e8e8e8;
    padding: 7.3px 0;
    display: flex;
    justify-content: space-around;
}
.listbtype{
    color: #C19030;
}
.listc{
  display: flex;
}
.listc ul{
    list-style-type: none;
    margin: 0;
}
.lista li>div{
    line-height: 21px;
    height: 21px;
}
.listtitle{
    width: calc(100% - 150px);
    text-align: left;
    color: black;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
}
.listtitle a{
    color: black;
    text-decoration: none;
}
.listtitle a:hover{
    color: #4e4e4e;
    text-decoration: none;
}
.pagination{
    text-align: right;
    margin-top: 25px;
}
.listmenu{
    float: left;
    width: 260px;
    text-align: center;
    /* border-right: 1px solid #e7e7e7; */
    /* margin-top: 60px; */
}
.listmenu li{
    display: inline-block;
    width: 201px;
    height: 52px;
    /* background: #BF3B31; */
    /* color: aliceblue; */
    background: #F8F8F8;
    font-size: 17px;
    font-weight: 400;
    line-height: 53px;
    cursor: pointer;
    /* border-bottom: 1px solid #e7e7e7; */
}
.listul>li>ul>li:hover{
    background: #175EC6!important;
    color: aliceblue;
}
.listZC .listmenu li:hover{
    background: #175EC6!important;
    color: aliceblue;
}
.listZC .listmenu li{
    border-bottom: 1px solid #e7e7e7;
}
.listul{
  padding-left: 0;
  width: 260px;
  text-align: center;
}
.listul>li{
    height: auto;
    width: 260px;
    background: unset;
}
.listul>li>span{
    width: 100%;
    display: inline-block;
    background: #175EC6;
    color: aliceblue;
    margin-bottom: 1px;
}
.listul>li>ul{
    width: 201px;
    padding-left: 0;
    /* padding-left: 59px; */
    text-align: center;
    margin: auto;
}
.active{
    background: #175EC6!important;
    color: aliceblue;
}
.topmenu{
    display: inline-block;
    width: 100%;
    /* height: 60px; */
    height: 52px;
    text-align: left;
    border-bottom: 1px dashed #8C8C8C;
}
.topmenu span{
    display: inline-block;
    text-align: center;
    width: 168px;
    height: 60px;
    font-size: 17px;
    font-weight: 600;
    color: #353A45;
    line-height: 60px;
    cursor: pointer;
}
.topRactive{
    color: #2578E0!important;
}
.ulclose{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/list.vue